import React from 'react';
import Input from '../elements/Input';

const Identification = ({ formData, handleChange }) => {
  return (
    <div>
      <h2 className="text-xl font-semibold mt-8 mb-2 border-b pb-1 dark:text-white">Identification</h2>
      <div className="grid md:grid-cols-2 gap-6 my-6">
        <div className="mb-4">
          <label className="block font-semibold mb-1 text-gray-800 dark:text-white">Identification Carried Out</label>
          <div className="flex items-center">
            <input
              type="radio"
              id="id_carried_out_yes"
              name="id_carried_out"
              value="Yes"
              checked={formData.id_carried_out === 'Yes'}
              onChange={handleChange}
              className="mr-2"
            />
            <label htmlFor="id_carried_out_yes" className="mr-4 text-gray-700 dark:text-gray-300">Yes</label>

            <input
              type="radio"
              id="id_carried_out_no"
              name="id_carried_out"
              value="No"
              checked={formData.id_carried_out === 'No'}
              onChange={handleChange}
              className="mr-2"
            />
            <label htmlFor="id_carried_out_no" className="text-gray-700 dark:text-gray-300">No</label>
          </div>
        </div>
        <Input label="Evidence Relied Upon" type="text" name="evidence_relied_upon" value={formData.evidence_relied_upon} onChange={handleChange} />
        <Input label="Name of Conflict Check" type="text" name="conflict_check" value={formData.conflict_check} onChange={handleChange} />
        <Input label="Source of Funding Out Costs (Self / Sponsor / Other)" type="text" name="funding_source" value={formData.funding_source} onChange={handleChange} />
      </div>
    </div>
  );
};

export default Identification;
